export class VoiceChat {

    stream = null;
    players;

    constructor(players) {
        navigator.getUserMedia = (navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia);
        this.players = players;
    }

    async startVoiceChat() {
        if (this.stream) {
            console.warn('already started');
            return this.stream;
        }

        const constraints = {
            audio: true,
            video: false
        };

        try {
            const getUserMediaPromise = new Promise((resolve, reject) => navigator.getUserMedia(constraints, resolve, reject));
            // Get access to microphone
            this.stream = await getUserMediaPromise;
        } catch (err) {
            /* handle the error */
            console.error(err);
        }

        return this.stream;
    }

    playAudio = (stream, peerId) => {
        const audio = document.createElement('audio');
        audio.autoplay = true;
        audio.srcObject = stream;
        audio.id = peerId;
        document.body.appendChild(audio);
    }

    stopAudio = (peerId) => {
        // remove audio element from the document
        const audio = document.getElementById(peerId);
        if (!audio) {
            return;
        }
        audio.pause();
        audio.remove();
    }

    calcVolume(distance) {
        if (distance > 355) {
            return 0;
        }

        // return a value between 0 and 1
        return (355 - distance) / 355;
    }

    updatePeerVolume(peerId, distance) {
        const audioElement = document.getElementById(peerId);
        if (!audioElement) {
            return;
        }
        audioElement.volume = this.calcVolume(distance);
    }

}